import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

const DeliveryUtilizationReportContext = createContext();

export const DeliveryUtilizationReportProvider = ({ children }) => {
  const today = dayjs();
  const oneYearAgo = today.subtract(12, 'month');

  const [fromdate, setFromDate] = useState(oneYearAgo);
  const [todate, setToDate] = useState(today);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [summaryDetails, setSummaryDetails] = useState({
    utilizationColumns: [],
    utilizationTableData: [],
  });
  const contextValue = React.useMemo(
    () => ({
      fromdate,
      setFromDate,
      todate,
      setToDate,
      tableData,
      setTableData,
      summaryDetails,
      setSummaryDetails,
      loading,
      setLoading,
      refreshTrigger,
      triggerRefresh: () => setRefreshTrigger(prev => prev + 1),
    }),
    [
      fromdate,
      setFromDate,
      todate,
      setToDate,
      tableData,
      setTableData,
      summaryDetails,
      setSummaryDetails,
      loading,
      setLoading,
      refreshTrigger,
      setRefreshTrigger,
    ],
  );

  return (
    <DeliveryUtilizationReportContext.Provider value={contextValue}>
      {children}
    </DeliveryUtilizationReportContext.Provider>
  );
};

DeliveryUtilizationReportProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useDeliveryUtilizationReport = () => useContext(DeliveryUtilizationReportContext);
